import { render } from "./InfoPage.vue?vue&type=template&id=5edce589&scoped=true&ts=true"
import script from "./InfoPage.vue?vue&type=script&lang=ts"
export * from "./InfoPage.vue?vue&type=script&lang=ts"

import "./InfoPage.vue?vue&type=style&index=0&id=5edce589&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edce589"]])

export default __exports__